import orderBy from 'lodash/orderBy';

import { api } from 'redux/api/index.api';

export const prioritiesApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchOrganizationPriorities: builder.query({
      query: ({ organizationId, moduleType, limit }) => ({
        url: `businessOrganization/${organizationId}/module/${moduleType.toLowerCase()}/priority`,
        method: 'GET',
        params: {
          ...(limit && { limit }),
        },
      }),
      transformResponse: response => orderBy(response.values, 'position'),
      providesTags: ['BusinessPrioritiesList'],
    }),
    fetchWorkspacePriorities: builder.query({
      query: ({ organizationId, workspaceId, moduleType }) => ({
        url: `businessOrganization/${organizationId}/workspaces/${workspaceId}/module/${moduleType.toLowerCase()}/priority`,
        method: 'GET',
      }),
      transformResponse: response => orderBy(response.values, 'position'),
      providesTags: ['WorkspacePrioritiesList'],
    }),
    fetchSuperAdminPriorities: builder.query({
      query: ({ moduleType }) => ({
        url: `module/${moduleType.toLowerCase()}/priority`,
        method: 'GET',
      }),
      transformResponse: response => orderBy(response.values, 'position'),
      providesTags: ['SuperAdminPrioritiesList'],
    }),
    fetchProjectFormPriorities: builder.query({
      query: ({ projectId }) => ({
        url: `projects/${projectId}/forms-priorities`,
        method: 'GET',
      }),
    }),
    fetchProjectObservationPriorities: builder.query({
      query: ({ projectId }) => ({
        url: `projects/${projectId}/observations-priorities`,
        method: 'GET',
      }),
    }),
    updateOrganizationPriorities: builder.mutation({
      query: ({ organizationId, moduleType, priorities }) => ({
        url: `businessOrganization/${organizationId}/module/${moduleType.toLowerCase()}/priority`,
        method: 'PUT',
        body: priorities,
      }),
      invalidatesTags: ['BusinessPrioritiesList'],
    }),
    updateWorkspacePriorities: builder.mutation({
      query: ({ organizationId, workspaceId, moduleType, priorities }) => ({
        url: `businessOrganization/${organizationId}/workspaces/${workspaceId}/module/${moduleType.toLowerCase()}/priority`,
        method: 'PUT',
        body: priorities,
      }),
      invalidatesTags: ['WorkspacePrioritiesList'],
    }),
    updateSuperAdminPriorities: builder.mutation({
      query: ({ moduleType, priorities }) => ({
        url: `module/${moduleType.toLowerCase()}/priority`,
        method: 'PUT',
        body: priorities,
      }),
      invalidatesTags: ['SuperAdminPrioritiesList'],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchOrganizationPrioritiesQuery,
  useLazyFetchOrganizationPrioritiesQuery,
  useFetchWorkspacePrioritiesQuery,
  useLazyFetchWorkspacePrioritiesQuery,
  useFetchSuperAdminPrioritiesQuery,
  useFetchProjectFormPrioritiesQuery,
  useFetchProjectObservationPrioritiesQuery,
  useUpdateOrganizationPrioritiesMutation,
  useUpdateWorkspacePrioritiesMutation,
  useUpdateSuperAdminPrioritiesMutation,
} = prioritiesApi;
